export const MODAL_TRANSITION = 300
export const DRAWER_TRANSITION = 300

export const TOAST_SHOW_TIME = 4000
export const IMAGE_MIME_TYPE = /image\/(png|jpg|jpeg)/i
export const IMAGE_OR_PDF_MIME_TYPE = /image\/(png|jpg|jpeg)|application\/pdf/i

export const ONE_MB_IN_BYTES = 1048576

export const MaxNumberOfImagesInOnePost = 1
export const MaxNumberOfImagePostsAtOnce = 3

export const FIFTEEN_MINUTES_IN_MILLISECONDS = 1000 * 60 * 15
export const THIRTIE_MINUTES_IN_MILLISECONDS = 1000 * 60 * 30
export const ONE_HOUR_IN_MILLISECONDS = 1000 * 60 * 60
export const DRAG_AND_DROP_DELAY_IN_MILLISECONDS_LARGE = 1000
export const DRAG_AND_DROP_DELAY_IN_MILLISECONDS_SMALL = 200
export const DRAG_TOUCH_SLOP = 55
export const FADE_LABEL_IN_MILLISECONDS = 1000 * 5

export const REQUEST_RETRY_COUNT = 3

export const REG_INPUT_ONLY_NUMBERS = /[^\d.,+-]/g

export const SEARCH_MIN_LETTERS = 3
export const SEARCH_PAGE_SIZE = 20
export const ENTITIES_LIST_PAGE_SIZE = 500
export const VEHICLE_EVENTS_SEARCH_PAGE_SIZE = 500
export const SHORT_MONTH = {
  month: 'short',
}
export const LONG_WEED_DAY = {
  weekday: 'long',
}

// Catalog Category
export const BODY_CATEGORY_ID = 'CA3PI20003895'
export const UNTAGGED_CATEGORY_ID = '0'
export const KITS_CATEGORY_ID = 'KITS'

//Damage levels
export const SLIGHT_LEVEL_ID = 'TA3PM52936'
export const MEDIUM_LEVEL_ID = 'TA3PM52937'
export const EXTENSIVE_LEVEL_ID = 'TA3PM52938'
export const SLIGHT_LEVEL_CODE = 1
export const MEDIUM_LEVEL_CODE = 2
export const EXTENSIVE_LEVEL_CODE = 3
export const NONE_LEVEL_CODE = 4

// Default params
export const CATALOG_PARTS_LIST_DEFAULT_ORDERING = 'popularity'
export const CATALOG_PARTS_LIST_DEFAULT_SORT_DIRECTION = 'desc'

// Google maps
export const GOOGLE_MAP_API_KEY = 'AIzaSyDxNWSX09Bn27b-U276a7lOXNpVtqsS_oQ'
export const GOOGLE_MAP_MAP_ID = '317e906f16ff44007b32eb90'

//Canvas
export const CANVAS_IMAGE_WIDTH = 864
export const CANVAS_IMAGE_HEIGHT = 441
export const CANVAS_IMAGE_WIDTH_NATIVE = window.innerWidth
export const CANVAS_IMAGE_HEIGHT_NATIVE = window.innerHeight
export const CANVAS_IMAGE_WIDTH_DESKTOP_EXPAND = window.innerWidth
export const CANVAS_IMAGE_HEIGHT_DESKTOP_EXPAND = window.innerHeight

export const CANVAS_ACTION_DRAWING = 'drawing'
export const CANVAS_ACTION_SHAPE = 'shape'
export const CANVAS_ACTION_ROTATE = 'rotate'
export const CANVAS_ACTION_EDIT = 'edit'

export const ACTION_BUTTONS_IMAGES = 'image_buttons'
export const ACTION_BUTTONS_DOCS = 'document_buttons'

export const AUTO3P_STANDARD_RATE_ID = 'TA3PD2510001'

//Vehicle events items status
export const EVENT_ITEM_STATUS_NOT_CHECKED = 'TA3PD350000'
export const EVENT_ITEM_STATUS_CHECKED = 'TA3PD350001'
export const EVENT_ITEM_STATUS_INVALID = 'TA3PD350002'
export const EVENT_ITEM_STATUS_NOT_REQUIRED = 'TA3PD350009'

//Vehicle events mechanic items status
export const EVENT_ITEM_STATUS_MECHANIC_DONE = 'TA3PD360001'
export const EVENT_ITEM_STATUS_MECHANIC_NOT_DONE = 'TA3PD350002'

//Vehicle events items type
export const EVENT_ITEM_TYPE_CHECK = 'TA3PD349001'
export const EVENT_ITEM_TYPE_ACTION = 'TA3PD349002'
export const EVENT_ITEM_TYPE_MEASUREMENT = 'TA3PD349003'
export const EVENT_ITEM_TYPE_APPROVAL = 'TA3PD349004'
export const EVENT_ITEM_TYPE_GENERAL = 'TA3PD349005'
export const EVENT_ITEM_TYPE_ARRIVAL_APPROVAL = 'TA3PD349006'
export const EVENT_ITEM_TYPE_SIGNATURE = 'TA3PD349009'

export const ACTION_ITEM_TYPES = [
  EVENT_ITEM_TYPE_CHECK,
  EVENT_ITEM_TYPE_ACTION,
  EVENT_ITEM_TYPE_GENERAL,
  EVENT_ITEM_TYPE_ARRIVAL_APPROVAL,
]

//Vehicle Inventory Presence Status
export const UNCHECKED_STATUS_ID = 'TA3PD249000'
export const PRESENT_STATUS_ID = 'TA3PD249001'
export const MISSING_STATUS_ID = 'TA3PD249002'
export const FAULTY_STATUS_ID = 'TA3PD249003'

//Vehicle Inventory Presence Desc
export const UNCHECKED_DESC = 'Unchecked'

//Kits
export const KIT_ITEM_FILTER_BY_DEFAULT = 'default'
export const KIT_ITEM_FILTER_BY_OPTIONAL = 'optional'

//App Monitor
export const APPLICATION_KEY = 'ReactFED'

//volkswagen theme id
export const VOLKSWAGEN_THEME_ID = 'vw'
//fid theme id
export const FID_THEME_ID = 'fid'

// Customer files list (services vs rentals) — API `fileType` query param
export const CUSTOMER_FILE_TYPE_SERVICE = 'TA3PREPFILE'
export const CUSTOMER_FILE_TYPE_RENTAL = 'TA3PRENTFILE'
